import React, { useEffect, useState } from 'react';
import { CalendarCheck, Phone } from 'lucide-react';
import { CONTACT } from '../lib/constants';
export function MobileStickyBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const hero = document.getElementById('top');
    if (!hero) return;
    const observer = new IntersectionObserver(([entry]) => setVisible(!entry.isIntersecting), {
      threshold: 0.08
    });
    observer.observe(hero);
    return () => observer.disconnect();
  }, []);
  return <div aria-hidden={!visible} className={`fixed inset-x-0 bottom-0 z-40 border-t border-border bg-white/95 shadow-lg backdrop-blur-md transition-transform duration-300 ease-smooth lg:hidden ${visible ? 'translate-y-0' : 'translate-y-full'}`} style={{
    paddingBottom: 'env(safe-area-inset-bottom)'
  }} data-id="element-112" data-mp="c3tvzvggcl2l">
      <div className="flex items-stretch gap-2 p-3" data-id="element-113" data-mp="zupf846ue7y8">
        <a href="#it-review" tabIndex={visible ? 0 : -1} className="flex min-h-[48px] flex-[2] items-center justify-center gap-2 rounded-btn bg-ct-cyan px-4 text-[15px] font-bold text-navy focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy" data-id="element-114" data-mp="uvwbh3hcxvb9">
          <CalendarCheck className="h-5 w-5" aria-hidden data-id="element-115" data-mp="te5415d0km4u" /> Free IT Review
        </a>
        <a href={CONTACT.phoneHref} tabIndex={visible ? 0 : -1} aria-label={`Call CT Group on ${CONTACT.phone}`} className="flex min-h-[48px] flex-1 items-center justify-center gap-2 rounded-btn border border-border bg-white px-4 text-[15px] font-bold text-navy focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ct-cyan" data-id="element-116" data-mp="xg05c9uy2zim">
          <Phone className="h-5 w-5 text-ct-cyan" aria-hidden data-id="element-117" data-mp="1h1cyes8wmas3" /> Call
        </a>
      </div>
    </div>;
}